import React, { useState, useRef } from "react";
import "./CardSpotLight.css"; // 👈 create this file

interface CardSpotlightProps {
  children: React.ReactNode;
  spotlightStrength?: number;
  borderRadiusPx?: number;
}

export const CardSpotlight = ({ children, spotlightStrength = 0.07, borderRadiusPx = 10 }: CardSpotlightProps) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!divRef.current) return;
    const rect = divRef.current.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

   const handleFocus = () => {
    setIsFocused(true);
    setOpacity(1);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setOpacity(0);
  };

  const handleMouseEnter = () => {
    setOpacity(1);
  };

  const handleMouseLeave = () => {
    setOpacity(0);
  };

  return (
     <div
      ref={divRef}
      onMouseMove={handleMouseMove}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="spotlight-container"
    >
      <div
        className="spotlight"
        style={{
          opacity,
          borderRadius: `${borderRadiusPx}px`,
          background: `radial-gradient(600px circle at ${position.x}px ${position.y}px, rgba(251, 230, 44, ${spotlightStrength}), transparent 40%)`,
        }}
      />

      <div className="spotlight-content">{children}</div>
    </div>
  );
};
